import { ObjectDefinition } from '../../types/DataSyncItem';
import { DataSyncObjectsStore } from './DataSyncObjectsStore';
import { directoryStore } from '../DirectoryStore';
import { ZipApi } from '../../lib/ZipApi';
import { observable } from 'mobx';
import { DestinationSchemaItem } from '../../types/Schema';

export default class DataSyncCrObjectsStore extends DataSyncObjectsStore {
  @observable private _destinationObjectList?: DestinationSchemaItem[];

  public getDestinationObjectList(): ObjectDefinition[] {
    if (!this._destinationObjectList) {
      return [];
    }
    return this._destinationObjectList.map((item) => {
      return {
        object_name: item.id,
        object_display_name: item.id || item.display_name,
        object_icon_url: '',
        fields: [],
      };
    });
  }

  protected async fetchSourceObjectDefinitions(): Promise<ObjectDefinition[]> {
    throw new Error('Content Recommendations as source is not supported');
  }

  protected async fetchDestinationObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }

    const response = await ZipApi.listDestinationSchemas(directoryStore.trackerId, 'CR', this.instanceId);

    if (response) {
      this._destinationObjectList = response.schemas || [];
    }

    return this.getDestinationObjectList();
  }
}
